import { useCallback, useEffect } from 'react'

import getScrollBarWidth from 'common/helpers/getters/getScrollBarWidth'


let openedModalsCount = 0

const useModalOpened = (enabled = true) => {

  const addStyles = useCallback(() => {
    document.body.classList.add('body-modal-opened')
    document.body.style.paddingRight = `${getScrollBarWidth()}px`
  }, [])

  const removeStyles = useCallback(() => {
    document.body.classList.remove('body-modal-opened')
    document.body.style.paddingRight = '0px'
  }, [])

  useEffect(() => {
    if (enabled) {
      if (openedModalsCount === 0) {
        addStyles()
      }
      openedModalsCount++

      return () => {
        openedModalsCount--

        if (openedModalsCount === 0) {
          removeStyles()
        }
      }
    }
  }, [ addStyles, removeStyles, enabled ])
}


export default useModalOpened
